import React, { useState, useEffect } from "react";
import BackButton from "../../BackButton/BackButton";
import styles from "./ExchangeConfirmation.module.css";

const ExchangeConfirmation = ( { newItemsSelectedOptions, productsBeingExchanged, setRenderExchangeConfirmation, setRenderDownloadLabel, setRenderItemExchange } ) => {
	const excludedKeys = ["unique_id", "product_title", "selected_product_image", "product_id", "product_sku", "product_cost"];

	return (
		<div className={styles.exchange_confirmation_container}>
			<p className={`${styles.confirm_exchange_title} titles`}>Confirm Exchange.</p>
			<div className={`${styles.exchange_confirmation_display_items_box} fade_in`}>
				<p className={styles.titles}>Returning {productsBeingExchanged.length} item{productsBeingExchanged.length > 1 ? 's' : ''}:</p>
				<div className={`${styles.item_box_wrapper} ${styles.items_being_exchanged_box}`}>
					{productsBeingExchanged.map((item, index) => (
						<div key={item.unique_id} className={styles.item_box}>
							<img src={item.product_image} alt={"product_image"} className={`${styles.product_images}`} />
							<div className={styles.product_title_wrapper}>
								<p className={styles.product_titles}>{item.product_title} / {item.product_variant}</p>
							</div>
						</div>
					))}
				</div>
				<p className={styles.titles}>You will receive:</p>
				<div className={`${styles.item_box_wrapper} ${styles.selected_items_box}`}>
					{newItemsSelectedOptions.map((item, index) => (
						<div key={index} className={styles.item_box}>
					    	<img src={item.selected_product_image} alt="selected_product_image" className={styles.product_images} />
					    	<div className={styles.product_title_wrapper}>
					      		<p className={styles.product_titles}>{Object.entries(item).filter(([key]) => !excludedKeys.includes(key)).map(([_, value]) => value).join(" / ")}</p>
					    	</div>
						</div>
					))}
				</div>
				<div className={`${styles.confirm_exchange_button} login_buttons`} onClick={() => { setRenderExchangeConfirmation(false); setRenderDownloadLabel(true); }}>Confirm</div>
			</div>
			<BackButton button_id={styles.exchange_confirmation_back_button} image_id={styles.exchange_confirmation_back_button_arrow} customBack={() => { setRenderExchangeConfirmation(false); setRenderItemExchange(true); }}/>
		</div>
	);
};

export default ExchangeConfirmation;